import * as service from "../service";
import type { ServiceResponse } from "../types";

type CancelBusinessSubscriptionParams = {
  /** true cancels at the end of the paid period, false re-enables auto-renewal. */
  cancel: boolean;
};

/**
 * Turn auto-renewal off (or back on) without losing the remaining paid period.
 * Backend: POST /api/business/plan/cancel
 */
export const CancelBusinessSubscriptionAPI = async ({
  cancel,
}: CancelBusinessSubscriptionParams): Promise<
  ServiceResponse<{
    cancel_at?: string | null;
    cancel_at_period_end?: boolean;
    renews_on?: string | null;
  }>
> => {
  try {
    const resp = (await service.call(
      "POST",
      "api/business/plan/cancel",
      { cancel },
    )) as ServiceResponse<{
      cancel_at?: string | null;
      cancel_at_period_end?: boolean;
      renews_on?: string | null;
    }>;
    return resp;
  } catch (err) {
    console.error(`CancelBusinessSubscriptionAPI ${err}`);
    return { status: -1, error: err };
  }
};
